module.exports = __webpack_public_path__ + "static/media/2DGACM14.e0b0d851.jpg";